import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { CREATE_REFERRAL_TYPE } from 'pages/valetServices/valetReferral/constants';

export const createEmployeeClientReferral = (formData) => async () => {
  const email = String(formData.email_id || '').trim();
  const remark = String(formData.remark || '').trim();

  const payload = {
    type: CREATE_REFERRAL_TYPE,
    data: {
      project_id: 1,
      name: String(formData.name || '').trim(),
      phone_number: String(formData.phone_number || '').trim(),
      property_name: String(formData.property_name || '').trim(),
      property_type: formData.property_type,
      ...(email ? { email_id: email } : {}),
      ...(remark ? { remark } : {}),
    },
  };

  const res = await callWebService(callTypes.post, payload, Config.siteLeadReferral.create);

  if (res?.data?.status === 0) {
    return res.data;
  }

  throw new Error(
    res?.data?.error || res?.data?.message || 'Failed to create referral'
  );
};
